import { useInView } from 'react-intersection-observer'
import { AboutCardProps } from '../../interfaces/common'
import CountUp from 'react-countup'

const AboutCard = ({ description, headerText, subHeader }: AboutCardProps) => {

  const { ref, inView } = useInView({
    triggerOnce: true, // 👈 only run once
    threshold: 0.3, // when 30% of the element is visible
  })
  const numberMatch = subHeader.match(/\d+/)
  const targetNumber = numberMatch ? parseInt(numberMatch[0]) : 0
  const hasPlus = subHeader.includes('+')
  const hasK = subHeader.toLowerCase().includes('k')
  const hasM = subHeader.toLowerCase().includes('m')

  const displayValue = (
    <CountUp
      end={targetNumber}
      duration={1.5} 
      separator=","
      enableScrollSpy 
      scrollSpyDelay={100}
    />
  )

  const suffix = hasM ? 'm' : hasK ? 'k' : hasPlus ? '+' : ''

  return (
    <div className="p-5 flex flex-col items-center justify-center border-2 border-white space-y-4 md:space-y-5 rounded-[10px] bg-[#F8F9FA4D]">
      <h3 className="text-xl md:text-[25px] font-normal text-[#000] whitespace-nowrap">
        {headerText}
      </h3>
      <p className="md:leading-10 text-[#000] font-bold text-[22px] md:text-[54px] whitespace-nowrap">
        {displayValue}
        {suffix}
      </p>
      <p className="md:leading-10 text-white font-normal text-[13px] md:text-[25px] whitespace-nowrap">
        {description}
      </p>
    </div>
  )
}

export default AboutCard
